import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRipple, MatRippleModule } from '@angular/material/core';
import { LayoutService } from '@app/layout/layout.service';
import { RouterModule } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { PublicReleaseFeedService } from '../public-release-feed.service';
import { ReleaseNotesStore } from '../release-notes.store';
import {
  PublicProjectRelease,
  RELEASE_FEED_ORG,
  RELEASE_FEED_PROJECT,
} from '../public-release-feed.model';

@Component({
  selector: 'app-indicator',
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatRippleModule,
    RouterModule,
    MatSnackBarModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './indicator.component.html',
  styleUrl: './indicator.component.scss',
  standalone: true,
  host: {
    class: 'w-100 pe-3',
  },
})
export class IndicatorComponent implements OnInit {
  @ViewChild(MatRipple) ripple?: MatRipple;
  @ViewChild('notifiticationVersion') notifiticationVersion?: TemplateRef<any>;

  closeProgress: number = 0;

  companyId: number | string = 0;
  isLoading: boolean = false;
  /** Latest published release, or null when the feed is empty/unreachable. */
  release: PublicProjectRelease | null = null;

  constructor(
    private feed: PublicReleaseFeedService,
    private store: ReleaseNotesStore,
    private layoutService: LayoutService,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.layoutService.companyId$.subscribe((companyId) => {
      if (companyId !== undefined) {
        this.companyId = +companyId;
      }
    });

    this.isLoading = true;
    this.feed.getLatest(RELEASE_FEED_ORG, RELEASE_FEED_PROJECT).subscribe({
      next: (release) => {
        this.release = release;
        this.isLoading = false;
        if (release && !this.store.isRead(release.version)) {
          this.notifyNewRelease();
        }
      },
      error: () => {
        this.release = null;
        this.isLoading = false;
      },
    });
  }

  private notifyNewRelease(): void {
    setTimeout(() => {
      const res = this.snackBar.openFromTemplate(
        this.notifiticationVersion as TemplateRef<any>,
        {
          duration: 10000,
          panelClass: ['text-white', 'bk-gray', 'version-notification', 'border-black'],
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
        }
      );
      res.afterOpened().subscribe(() => {
        const intervalRef = setInterval(() => {
          this.closeProgress += 1;
          if (this.closeProgress >= 100) {
            this.closeProgress = 0;
            clearInterval(intervalRef);
          }
        }, 100);
      });
    }, 2500);
  }

  dismiss(): void {
    if (this.release) {
      this.store.markRead(this.release.version);
    }
    this.closeProgress = 100;
    this.snackBar.dismiss();
  }
}
